import { SocialProof } from "@/src/cashback/LandingPage/Version/social-proof";
import { languageSelector } from "@/src/contexts/UserAuthenticationContext";
import { ConsentScreenType } from "@/src/modals/useConsents";
import PanelSection from "@/src/shared/panel-section";
import { LoginRegistrationCore } from "@Components/login-registration-core/login-registration-core";
import { TelemetryBoundary } from "@Components/telemetry-hoc/telemetry-boundary";

import * as css from "./../../CashbackTopSection.module.css";
import * as versionCss from "./lpVersionH.module.css";

export function LpTopComponentVersionH() {
    const ME_VERISON = "H";

    const resources = languageSelector(
        {
            title: "Dołącz do tych - którzy już zyskują na zakupach online",
        },
        {
            title: "Join those - who are already saving on online shopping",
        },
    );

    return (
        <PanelSection
            telemetryCustom={{
                eventName: "cshbck-TopSection",
                actionType: "View",
                param1: ME_VERISON,
            }}
            className={versionCss.lpVersionH}
            initialInView
        >
            <div className={versionCss.gridWrapper}>
                <div className={css.cashbackTopSectionComponent}>
                    <div className={css.textContent}>
                        <h1 className={css.subject} dangerouslySetInnerHTML={{ __html: resources.title }} />
                        <SocialProof />
                    </div>
                </div>

                <TelemetryBoundary
                    className={versionCss.formContainer}
                    telemetryCustom={{
                        eventName: "common-registerModal",
                        actionType: "View",
                        param1: ME_VERISON,
                    }}
                >
                    <LoginRegistrationCore
                        loginConsentScreenType={ConsentScreenType.LoginProcess}
                        registerConsentScreenType={ConsentScreenType.RegistrationProcess}
                        customRegisterButtonTelemetry={{
                            eventName: "cshbck-topSectionRegister",
                            actionType: "Click",
                            param1: ME_VERISON,
                        }}
                    />
                </TelemetryBoundary>
            </div>
        </PanelSection>
    );
}
